import { Navigate, Route, Routes } from 'react-router-dom';
import { SchoolDonationsDashboardPage } from './SchoolDonationsDashboardPage';
import { SchoolDonationsCampaignEditorPage } from './SchoolDonationsCampaignEditorPage';
import { SchoolDonationsModerationPage } from './SchoolDonationsModerationPage';
import { SchoolDonationsLedgerPage } from './SchoolDonationsLedgerPage';
import { SchoolDonationsSettingsPage } from './SchoolDonationsSettingsPage';
import { TeacherDailyHonoreesPage } from './TeacherDailyHonoreesPage';

export function SchoolDonationsSourceFaithfulRoutes() {
  return (
    <Routes>
      <Route index element={<SchoolDonationsDashboardPage />} />
      <Route path="campaigns/new" element={<SchoolDonationsCampaignEditorPage />} />
      <Route path="campaigns/:campaignId" element={<SchoolDonationsCampaignEditorPage />} />
      <Route path="moderation" element={<SchoolDonationsModerationPage />} />
      <Route path="ledger" element={<SchoolDonationsLedgerPage />} />
      <Route path="settings" element={<SchoolDonationsSettingsPage />} />
      <Route path="daily-honorees" element={<TeacherDailyHonoreesPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
